module.exports = __webpack_public_path__ + "static/media/yes_cardio.e8c09880.webp";